import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/setting-user',
          component: resolve => require(['../components/page/admin/newUser.vue'], resolve),
          meta: {
            title: '用户管理',
          },
        },
        {
          path: '/setting-role',
          component: resolve => require(['../components/page/admin/newRole.vue'], resolve),
          meta: {
            title: '角色管理',
          },
        },
        {
          path: '/setting-permission',
          component: resolve => require(['../components/page/admin/newPermission.vue'], resolve),
          meta: {
            title: '权限管理',
          },
        },
        {
          path: '/setting-view_permission',
          component: resolve => require(['../components/page/admin/view_permission.vue'], resolve),
          meta: {
            title: '页面权限管理',
          },
        },
        {
          path: '/setting-personal',
          component: resolve => require(['../components/page/admin/personal.vue'], resolve),
          meta: {
            title: '个人中心',
          },
        },
        {
          path: '/setting-nickname',
          component: resolve => require(['../components/page/admin/nicknameManage.vue'], resolve),
          meta: {
            title: '昵称管理',
          },
        },
        {
          name: 'gameStatus',
          path: '/setting-gameStatus',
          component: resolve => require(['../components/page/admin/gameStatus.vue'], resolve),
          meta: {
            title: '游戏现状态',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/work-work_sn',
          component: resolve => require(['../components/page/worksn/work_sn.vue'], resolve),
          meta: {
            title: '自助工单',
          },
        },
        {
          path: '/work-manMadeOrder',
          component: resolve => require(['../components/page/worksn/manMadeOrder.vue'], resolve),
          // component: () => import('@/components/page/worksn/work_log'),
          name: 'work_log',
          meta: {
            title: '人工工单',
          },
        },

        {
          path: '/work-work_statistics',
          component: resolve => require(['../components/page/worksn/work_statistics.vue'], resolve),
          // component: () => import('@/components/page/worksn/work_log'),
          name: 'work_statistics',
          meta: {
            title: '工单统计',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/work-work_log',
          component: resolve => require(['../components/page/configureSummary/work_log.vue'], resolve),
          // component: () => import('@/components/page/worksn/work_log'),
          name: 'work_log',
          meta: {
            title: '工单记录',
          },
        },
        // {
        //   path: '/work-work_kefu',
        //   component: resolve => require(['../components/page/configureSummary/work_kefu.vue'], resolve),
        //   // component: () => import('@/components/page/worksn/work_log'),
        //   name: 'work_kefu',
        //   meta: {
        //     title: '工单客服',
        //   },
        // },
        {
          path: '/work-work_prohibition',
          component: resolve => require(['../components/page/configureSummary/prohibition.vue'], resolve),
          // component: () => import('@/components/page/worksn/work_log'),
          name: 'work_prohibition',
          meta: {
            title: '封禁管理',
          },
        },
        {
          path: '/work-work_game_vips',
          component: resolve => require(['../components/page/configureSummary/work_game_vips.vue'], resolve),
          name: 'work_game_vips',
          meta: {
            title: 'vip管理',
          },
        },
        {
          path: '/work-work_question_config',
          component: resolve => require(['../components/page/configureSummary/work_question_config.vue'], resolve),
          name: 'work_question_config',
          meta: {
            title: '常见问题',
          },
        },
        {
          path: '/work-work_question_type',
          component: resolve => require(['../components/page/configureSummary/work_question_type.vue'], resolve),
          name: 'work_question_type',
          meta: {
            title: '常见问题类型',
          },
        },
        {
          path: '/work-work_reply',
          component: resolve => require(['../components/page/configureSummary/work_reply.vue'], resolve),
          name: 'work_reply',
          meta: {
            title: '快捷回复设置',
          },
        },
        {
          path: '/work-data_statistics',
          component: resolve => require(['../components/page/configureSummary/data_statistics.vue'], resolve),
          name: 'data_statistics',
          meta: {
            title: '数据统计',
          },
        },
        {
          path: '/work-early-warning',
          component: resolve => require(['../components/page/configureSummary/early_warning/index.vue'], resolve),
          name: 'early_warning',
          meta: {
            title: '报警预警',
          },
        },
        {
          path: '/work-commentType',
          component: resolve => require(['../components/page/configureSummary/commentType.vue'], resolve),
          meta: {
            title: '评价类型',
          },
        },
        {
          path: '/work-openHookAccount',
          component: resolve => require(['../components/page/configureSummary/work_openHook_account.vue'], resolve),
          meta: {
            title: '开挂账号管理',
          },
        },
      ],
    },

    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        // {
        //   path: '/customer-time_notice',
        //   component: resolve => require(['../components/page/customer/time_notice.vue'], resolve),
        //   meta: {
        //     title: '实时通知',
        //   },
        // },
        {
          path: '/customer-time_notice_view',
          component: resolve => require(['../components/page/customer/time_notice_view.vue'], resolve),
          meta: {
            title: '通知-查看详情',
          },
        },
        {
          path: '/customer-problem',
          component: resolve => require(['../components/page/customer/problem.vue'], resolve),
          meta: {
            title: '问题交接',
          },
        },
          {
          path: '/send-verificationCode',
          component: resolve => require(['../components/page/customer/send_verificationCode.vue'], resolve),
          meta: {
            title: '发送验证码',
          },
        },
        {
          path: '/customer-problem_content_view',
          component: resolve => require(['../components/page/customer/problem_content_view.vue'], resolve),
          meta: {
            title: '问题-查看详情',
          },
        },
        {
          path: '/customer-gift_bag',
          component: resolve => require(['../components/page/customer/gift_bag.vue'], resolve),
          meta: {
            title: '安抚礼包',
          },
        },
        {
          path: '/customer-gift_content_view',
          component: resolve => require(['../components/page/customer/gift_content_view.vue'], resolve),
          meta: {
            title: '礼包内容查看',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/dpartmentSmmary-CPGameAdmin',
          component: resolve => require(['../components/page/dpartmentSmmary/CPGameAdmin.vue'], resolve),
          meta: {
            title: 'CP游戏后台',
          },
        },
        {
          name: 'history',
          path: '/dpartmentSmmary-history/:id',
          component: resolve => require(['../components/page/dpartmentSmmary/history.vue'], resolve),
          meta: {
            title: '历史记录',
          },
        },
        {
          name: 'gameOperation',
          path: '/dpartmentSmmary-gameOperation',
          component: resolve => require(['../components/page/dpartmentSmmary/gameOperation.vue'], resolve),
          meta: {
            title: '游戏运营对接',
          },
        },
        {
          path: '/dpartmentSmmary-complaint',
          component: resolve => require(['../components/page/dpartmentSmmary/complaint.vue'], resolve),
          meta: {
            title: '投诉记录',
          },
        },
        {
          path: '/dpartmentSmmary-complaint_histoty',
          component: resolve => require(['../components/page/dpartmentSmmary/complaint_histoty.vue'], resolve),
          meta: {
            title: '历史操作记录',
          },
        },
        {
          path: '/dpartmentSmmary-indulge_link',
          component: resolve => require(['../components/page/dpartmentSmmary/indulge_link.vue'], resolve),
          meta: {
            title: '防沉迷链接',
          },
        },
        {
          path: '/dpartmentSmmary-applicationGoods',
          component: resolve => require(['../components/page/dpartmentSmmary/applicationGoods.vue'], resolve),
          meta: {
            title: '物品补发申请',
          },
        },

        {
          path: '/dpartmentSmmary-bill_record',
          component: resolve => require(['../components/page/dpartmentSmmary/bill_record.vue'], resolve),
          name: 'bill_record',
          meta: {
            title: '发票记录',
          },
        },
        {
          path: '/dpartmentSmmary_linkHistory',
          component: resolve => require(['../components/page/dpartmentSmmary/linkHistory.vue'], resolve),
          meta: {
            title: '历史记录',
          },
        },
        {
          path: '/dpartmentSmmary_morePage/affice',
          name: 'morePage.affice',
          component: resolve => require(['../components/page/dpartmentSmmary/morePage.vue'], resolve),
          meta: {
            title: '重要通知',
          },
        },
        {
          path: '/dpartmentSmmary_morePage/activity',
          name: 'morePage.activity',
          component: resolve => require(['../components/page/dpartmentSmmary/morePage.vue'], resolve),
          meta: {
            title: '特定通知',
          },
        },
        {
          path: '/dpartmentSmmary_morePage/notify',
          name: 'morePage.notify',
          component: resolve => require(['../components/page/dpartmentSmmary/morePage.vue'], resolve),
          meta: {
            title: '部门资料',
          },
        },
        {
          path: '/dpartmentSmmary_uploadFile',
          component: resolve => require(['../components/page/dpartmentSmmary/uploadFile.vue'], resolve),
          meta: {
            title: '文件上传',
          },
        },
        {
          path: '/dpartmentSmmary-packageSwitchStrategy',
          component: resolve => require(['../components/page/dpartmentSmmary/packageSwitchStrategy.vue'], resolve),
          name: 'package_switch_strategy',
          meta: { title: '切包策略配置' },
        },
        {
          path: '/dpartmentSmmary-invoiceEntityConfig',
          component: resolve => require(['../components/page/dpartmentSmmary/invoiceEntityConfig.vue'], resolve),
          name: 'invoice_entity_config',
          meta: { title: '自动开票主体配置' },
        },
        {
          path: '/dpartmentSmmary-invoiceRecord',
          component: resolve => require(['../components/page/dpartmentSmmary/invoiceRecord.vue'], resolve),
          name: 'invoice_record',
          meta: { title: '开票记录' },
        },
        {
          path: '/dpartmentSmmary-serviceRecord',
          component: resolve => require(['../components/page/dpartmentSmmary/serviceRecord.vue'], resolve),
          meta: {
            title: '玩家建议',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/faq-index',
          component: resolve => require(['../components/page/faq/index.vue'], resolve),
          meta: {
            title: 'FAQ知识库',
          },
        },
        {
          path: '/faq-center',
          component: resolve => require(['../components/page/faq/center.vue'], resolve),
          name: 'center',
          meta: {
            title: '个人中心',
          },
        },
        {
          path: '/faq-type',
          component: resolve => require(['../components/page/faq/game.vue'], resolve),
          name: 'type',
          redirect: '/faq-type/game',
          meta: {
            title: 'FAQ知识库后台',
          },
          children: [
            {
              path: 'game',
              component: resolve => require(['../components/page/faq/fqGame.vue'], resolve),
              name: 'type.game',
              meta: {
                title: '游戏名配置',
              },
            },
            {
              path: 'type',
              component: resolve => require(['../components/page/faq/fqType.vue'], resolve),
              name: 'type.type',
              meta: {
                title: '问题类型配置',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/sessionList',
          component: resolve => require(['../components/page/vipQualityTest/sessionList.vue'], resolve),
          meta: {
            title: '会话列表',
          },
        },
        {
          path: '/dutyList',
          component: resolve => require(['../components/page/vipQualityTest/dutyList.vue'], resolve),
          meta: {
            title: '客服昵称对应关系',
          },
        },
        {
          path: '/userInfoQuery',
          component: resolve => require(['../components/page/vipQualityTest/userInfoQuery/index.vue'], resolve),
          meta: {
            title: '用户信息查询',
          },
        },
        {
          path: '/uploadExcel',
          component: resolve => require(['../components/page/vipQualityTest/uploadExcel.vue'], resolve),
          meta: {
            title: '上传excel',
          },
        },
        // 新增的超时配置的页面
        {
          path: '/overTimeSet',
          component: resolve => require(['../components/page/vipQualityTest/overTimeSet.vue'], resolve),
          meta: {
            title: '超时配置',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/ordinaryReport',
          component: resolve => require(['../components/page/ordinaryReport/index.vue'], resolve),
          meta: {
            title: '普客工作汇报',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '客服工作数据',
      },
      children: [
        {
          path: '/ordinaryData',
          component: resolve => require(['../components/page/workData/ordinaryData.vue'], resolve),
          meta: {
            title: '普客客服数据',
          },
        },
        {
          path: '/vipData',
          component: resolve => require(['../components/page/workData/vipData.vue'], resolve),
          meta: {
            title: 'vip客服数据',
          },
        },
        {
          path: '/testData',
          component: resolve => require(['../components/page/workData/testData.vue'], resolve),
          meta: {
            title: '质检客服数据',
          },
        },
        {
          path: '/worksnData',
          component: resolve => require(['../components/page/workData/worksnData.vue'], resolve),
          meta: {
            title: '工单客服数据',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '质检分析',
      },
      children: [
        {
          path: '/worksnAnalysis',
          component: resolve => require(['../components/page/testAnalysis/worksnAnalysis.vue'], resolve),
          meta: {
            title: '工单质检分析',
          },
        },
        {
          path: '/vipAnalysis',
          component: resolve => require(['../components/page/testAnalysis/vipAnalysis.vue'], resolve),
          meta: {
            title: 'vip质检分析',
          },
        },
        {
          path: '/oridinaryAnalysis',
          component: resolve => require(['../components/page/testAnalysis/oridinaryAnalysis.vue'], resolve),
          meta: {
            title: '普客质检分析',
          },
        },
        {
          path: '/weixinAnalysis',
          component: resolve => require(['../components/page/testAnalysis/weixinAnalysis.vue'], resolve),
          meta: {
            title: '微信质检分析',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/dashboard',
          component: resolve => require(['../components/page/Dashboard.vue'], resolve),
          meta: {
            title: '系统首页',
          },
        },
        {
          path: '/404',
          component: resolve => require(['../components/page/404.vue'], resolve),
          meta: {
            title: '404',
          },
        },
        {
          path: '/403',
          component: resolve => require(['../components/page/403.vue'], resolve),
          meta: {
            title: '403',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/table',
          component: resolve => require(['../components/page/BaseTable.vue'], resolve),
          meta: {
            title: '基础表格',
          },
        },
        {
          path: '/form',
          component: resolve => require(['../components/page/BaseForm.vue'], resolve),
          meta: {
            title: '基本表单',
          },
        },
        {
          path: '/icon',
          component: resolve => require(['../components/page/Icon.vue'], resolve),
          meta: {
            title: '自定义图标',
          },
        },
        {
          path: '/tabs',
          component: resolve => require(['../components/page/Tabs.vue'], resolve),
          meta: {
            title: 'tab选项卡',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '企微会话记录',
      },
      children: [
        {
          path: '/employeeList',
          component: resolve => require(['../components/page/wechatWork/employeeList.vue'], resolve),
          meta: {
            title: '企微会话查询',
          },
        },
        {
          path: '/qwAiQualityList',
          component: resolve => require(['../components/page/wechatWork/aiQuality/index.vue'], resolve),
          meta: {
            title: 'AI质检',
          },
        },
        {
          path: '/qwAiQualityDashboard',
          component: resolve => require(['../components/page/wechatWork/aiQuality/dashboard.vue'], resolve),
          meta: {
            title: 'AI质检看板',
          },
        },
      ],
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      meta: {
        title: '商户号投诉处理',
      },
      children: [
        {
          path: '/wx_merchant_complaint_handle',
          component: resolve => require(['../components/page/merchantComplaintHandle/wxMerchant/index.vue'], resolve),
          meta: {
            title: '微信商户号',
          },
        },
        {
          path: '/zfb_merchant_complaint_handle',
          component: resolve => require(['../components/page/merchantComplaintHandle/zfbMerchant/index.vue'], resolve),
          meta: {
            title: '支付宝商户号',
          }
        },
      ]
    },
    {
      path: '/login',
      component: resolve => require(['../components/page/login/login.vue'], resolve),
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      children: [
        {
          path: '/complaint-feishu-group-config',
          component: resolve => require(['../components/page/complaintProcessing/feishuGroupConfig.vue'], resolve),
          meta: { title: '客诉反馈飞书群配置' },
        },
        {
          path: '/complaint-feedback-records',
          component: resolve => require(['../components/page/complaintProcessing/feedbackRecords.vue'], resolve),
          meta: { title: '客诉处理记录' },
        },
      ],
    },
    {
      path: '/aiToolbar',
      component: resolve => require(['../components/page/aiToolbar/index.vue'], resolve),
    },
    {
      path: '/complaintFeedback',
      component: resolve => require(['../components/page/complaintFeedback/index.vue'], resolve),
      meta: { title: '客诉反馈' },
    },
    {
      path: '/vipGiftRecommend',
      component: resolve => require(['../components/page/vipGiftRecommend/index.vue'], resolve),
      meta: {
        title: 'VIP礼包推荐',
      },
    },
    {
      path: '/promotionSubmit',
      component: resolve => require(['../components/page/promotionSubmit/index.vue'], resolve),
      meta: {
        title: '促单提交',
      },
    },
    {
      path: '/qwReplyRecommend',
      component: resolve => require(['../components/page/qwReplyRecommend/index.vue'], resolve),
      meta: {
        title: '企微推荐话术',
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});
